import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-3 col-sm-6">
            <div className="footer-widget footer-widget__about">
              <a href="#">
                <img src="assets/images/centurynew.png" width={155} alt="" />
              </a>
              <p>
                Century Loans was incorporated in 2020 under the laws of Zambia
                Companies Act No.10 of 2017 in the companies register.
              </p>
              <div className="footer-widget__about-phone">
                <i className="pylon-icon-telephone" />
                <div className="footer-widget__about-phone-content">
                  <span>Call Anytime</span>
                  <h3>
                    <a href="#">+260772314242 / +260760665151</a>
                  </h3>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-2 col-sm-6">
            <div className="footer-widget footer-widget__link">
              <h3 className="footer-widget__title">Explore</h3>
              <ul className="list-unstyled footer-widget__link-list">
                <li>
                  <a href="/">
                    <i className="fa fa-arrow-right" />
                    Our Services
                  </a>
                </li>
                <li>
                  <a href="/">
                    <i className="fa fa-arrow-right" />
                    About
                  </a>
                </li>
                <li>
                  <Link to={"/contacts"}>
                    <i className="fa fa-arrow-right" />
                    Contact
                  </Link>
                </li>
              </ul>
              {/* /.list-unstyled */}
            </div>
            {/* /.footer-widget */}
          </div>

          <div className="col-lg-4 col-sm-6">
            <div className="footer-widget footer-widget__contact">
              <h3>Contact</h3>
              <ul className="list-unstyled footer-widget__contact-list">
                <li>
                  <a href="#">
                    <i className="pylon-icon-email1" />
                    info@centuryloans.net
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="pylon-icon-clock2" />
                    Mon - Fri 8:00 AM - 5:00 PM
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="pylon-icon-pin1" />
                    Plot No. 14 Martin Mwamba Road, Olympia, Lusaka - Zambia
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
